import { useMemo } from 'react';

import { useTheme } from '@mui/material';

import { useTranslate } from 'src/locales';
import { ApplicationStatus } from 'src/services/applications/applications.types';

import Label, { LabelProps } from 'src/components/label';

export function ApplicationStatusLabel(props: LabelProps & { status: ApplicationStatus }) {
  const { status } = props;

  const { t } = useTranslate();

  const theme = useTheme();

  const colorCode = useMemo(() => {
    if (status === ApplicationStatus.ACTIVE) {
      return "primary"
    }
    if (status === ApplicationStatus.ARCHIVED) {
      return "warning"
    }

    return undefined;
  }, [status]);

  return (
    <Label
      variant="soft"
      color={colorCode}
    >
      {t(`enums.application_status.${status}`)}
    </Label>
  );
}
